module.exports = __webpack_public_path__ + "static/assets/3eb016636cb3c47144c46e5fa67ad508.png";